export const getUser = state => state.user.current || {};
export const getAnonymousUserHasViewedWelcomeModal = state => state.user.anonymousUserHasViewedWelcomeModal;
